/** Letters per word. */
export const WORD_LENGTH = 5;

/** Guesses allowed before the round is lost. */
export const MAX_GUESSES = 6;

/** Points for solving the puzzle at all. */
export const SOLVE_POINTS = 3;

/** Bonus for being one of the first {@link EARLY_SOLVER_COUNT} solvers of the day. */
export const EARLY_SOLVER_BONUS = 2;

/** How many of the day's first solvers earn {@link EARLY_SOLVER_BONUS}. */
export const EARLY_SOLVER_COUNT = 5;

/** The leaderboard day rolls over at midnight in this zone (the Rise countdown runs on New Orleans time). */
export const LEADERBOARD_TIME_ZONE = "America/Chicago";

/** Player names must be at least this long. */
export const MIN_NAME_LENGTH = 2;

/** Mirrors `wordle_results.name varchar(50)`. */
export const MAX_NAME_LENGTH = 50;

/** How often the leaderboard refreshes while the page is open. */
export const LEADERBOARD_REFRESH_MS = 30_000;

/** localStorage key for the in-progress or finished round. */
export const GAME_STORAGE_KEY = "nowadays-wordle-round";

/** localStorage key for the last name a player used. */
export const NAME_STORAGE_KEY = "nowadays-wordle-name";

/** Delay between tile flips when a row is revealed. */
export const TILE_FLIP_STAGGER_MS = 120;

/** How long a toast stays on screen. */
export const TOAST_DURATION_MS = 1800;

/** On-screen keyboard rows. */
export const KEYBOARD_ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["ENTER", "Z", "X", "C", "V", "B", "N", "M", "BACKSPACE"],
] as const;
